import { gql } from '@apollo/client';

export const UPDATE_FEATURE_FLAG_MUTATION = gql`
  mutation updateFeatureFlagMutation($_id: String!, $key: String!, $value: Boolean!) {
    updateFeatureFlag(_id: $_id, key: $key, value: $value)
  }
`;
